import data from '../content/testimonials.json';

export type Testimonial = (typeof data.items)[number];
export type TestimonialCategory = Testimonial['category'] | 'all';

export function getTestimonials() {
  return data;
}

export function featuredTestimonials(n = 3): Testimonial[] {
  const featured = data.items.filter((t) => t.featured);
  const pool = featured.length > 0 ? featured : data.items;
  return pool.slice(0, n);
}

export function testimonialsByCategory(category: TestimonialCategory): Testimonial[] {
  if (category === 'all') return data.items;
  return data.items.filter((t) => t.category === category);
}
